import Navbar from "../components/Navbar";

const Terms: React.FC = () => (
  <div className="min-h-screen bg-gray-100 flex flex-col">
    <Navbar />
    <div className="w-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white py-16 flex flex-col items-center">
      <h1 className="w-full text-4xl md:text-5xl font-light mb-4 text-center">Terms of Service</h1>
      <p className="w-full text-lg md:text-xl opacity-90 max-w-xl mx-auto text-center">
        Please read our terms and conditions before using Musicade.
      </p>
    </div>
  <div className="w-full py-16 bg-white">
      <div className="privacy-container min-w-full">
        
        <div className="iubenda-container w-full mt-8">
          <iframe
            src="https://www.iubenda.com/terms-and-conditions/31795037"
            title="Terms and Conditions"
            width="100%"
            height="600"
            style={{ border: 'none', borderRadius: '12px', background: 'white' }}
            allowFullScreen
          />
        </div>
        <div className="mt-10 text-left bg-gray-50 rounded-xl p-6 shadow flex flex-col items-start max-w-md mx-auto">
          <h3 className="text-xl font-bold mb-2">Contact Us</h3>
          <p className="mb-3">If you have any questions about these terms of service or our privacy practices, please contact us:</p>
          <ul className="mt-2 space-y-2">
            <li><strong>Email:</strong> privacy@yoursite.com</li>
            <li><strong>Phone:</strong> +1 (555) 123-4567</li>
            <li><strong>Address:</strong> 123 Your Street, Your City, State 12345</li>
          </ul>
        </div>
      </div>
    </div>
    <footer className="footer bg-gray-900 text-white py-8 text-center mt-auto">
      <div className="container mx-auto">
        <p>&copy; 2025 Musicade. All rights reserved.</p>
        <div className="footer-links mt-2">
          <a href="/terms" className="text-indigo-200 hover:underline mr-4">Terms of Service</a>
        </div>
      </div>
    </footer>
  </div>
);

export default Terms;
